export const GIT_PUBLISHING_BRANCH_NAME = "main";
export const GIT_PUBLISHING_REMOTE_NAME = "moment";
